// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2jL9Z","calendarButtons":"ClockData_calendarButtons__3UNYP"};